import { render } from "./HomeInfo.vue?vue&type=template&id=5aaf48f2&scoped=true&ts=true"
import script from "./HomeInfo.vue?vue&type=script&lang=ts"
export * from "./HomeInfo.vue?vue&type=script&lang=ts"

import "./HomeInfo.vue?vue&type=style&index=0&id=5aaf48f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaf48f2"]])

export default __exports__